var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('router-link',{attrs:{"to":"/cartera"}},[_c('img',{staticClass:"p-2",attrs:{"src":_vm.getLogo(),"alt":"Ninety Nine Logo"}})]):_c('img',{staticClass:"p-2",attrs:{"src":_vm.getLogo(),"alt":"Ninety Nine Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }